import {
	ModuleSettingCollisionError,
	SachbezugErrors,
} from "@service/product/errors";
import { DeserializableFromResponse, ErrorBase } from "@util/errors";
import {
	CustomerNotFoundError,
	IncompatibleModuleWithAccountingMonthSettingError,
	ModuleSettingDateRangeError,
	ModuleSettingMaxAmountBelowUsedAmountError,
	MonthClosedForChangesError,
	ThirdPartyCategoryNotAllowedError,
	ThirdPartyVouchersNotEnabledError,
} from "./errors";
import {
	AccountingMonthGapDetectedError,
	AccountingMonthIllegalStatusTransitionError,
	ApprovedDetachedVouchersError,
	PricingSettingNotFoundError,
	ExcessBudgetDisabledError,
	ExpenseAccountMissingError,
	InvalidReportSettingsError,
	PostingKeyMissingError,
	UnreviewedVouchersError,
	WageKeyMissingError,
	WageTypeMissingError,
} from "@service/accountingMonth/error";
import {
	CategoryDisabledError,
	DivisionCreationCustomerStatusError,
	DivisionNotFoundError,
	ExcessBudgetConfigurationInvalidError,
} from "@service/division/errors";
import {
	MoveUserToDivisionAssetsError,
	MoveUserToDivisionSachbezugMonthClosedError,
	UserNotFoundError,
} from "@service/user/errors";

/** a list of known errors that are DeserializableFromResponse */
export const knownErrors: DeserializableFromResponse<ErrorBase>[] = [
	CustomerNotFoundError,
	DivisionNotFoundError,
	UserNotFoundError,
	ExcessBudgetDisabledError,
	ModuleSettingCollisionError,
	MonthClosedForChangesError,
	ThirdPartyVouchersNotEnabledError,
	ThirdPartyCategoryNotAllowedError,
	UnreviewedVouchersError,
	ApprovedDetachedVouchersError,
	AccountingMonthIllegalStatusTransitionError,
	AccountingMonthGapDetectedError,
	WageTypeMissingError,
	WageKeyMissingError,
	InvalidReportSettingsError,
	PostingKeyMissingError,
	ExpenseAccountMissingError,
	...SachbezugErrors,
	MoveUserToDivisionAssetsError,
	MoveUserToDivisionSachbezugMonthClosedError,
	DivisionCreationCustomerStatusError,
	PricingSettingNotFoundError,
	CategoryDisabledError,
	ModuleSettingDateRangeError,
	ModuleSettingMaxAmountBelowUsedAmountError,
	IncompatibleModuleWithAccountingMonthSettingError,
	ExcessBudgetConfigurationInvalidError,
];
